<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-12 16:15:56
 -->
<template>
  <div class="user">
    <div class="thumb"></div>
    <div class="info">
      <span class="name" style="cursor: pointer">{{ username }}，您好</span>
    </div>
    <button class="close" title="我的信息">
      <el-dropdown>
        <span class="el-dropdown-link"
          ><i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item
            ><span @click="changeindex">首页</span></el-dropdown-item
          >
          <el-dropdown-item
            ><span @click="change">我的信息</span></el-dropdown-item
          > -->
          <el-dropdown-item
            ><span @click="loginout">退出登录</span></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </button>
  </div>
</template>

<script>
import utils from "@/plugins/utils";
import Bus from "@/plugins/upload/bus";
import { user_info, login_out } from "@/api/file";
export default {
  inject: ["reload"],
  components: {},
  data() {
    return {
      states: "",
      username: "",
      userType: 0,
    };
  },

  created() {},
  mounted() {
    this.getuserinfo();
  },
  methods: {
    change() {
      Bus.$emit("getstates", (this.states = 2));
      this.$router.push("/web/myinfo");
    },
    changeindex() {
      Bus.$emit("getstates", (this.states = 1));
      this.$router.push("/web/home");
    },
    //获取用户信息
    getuserinfo() {
      user_info().then((res) => {
        this.username = res.data.username;
      });
    },
    //退出
    loginout() {
      login_out(this.userType).then((res) => {
        if (res.code == 200) {
          this.$confirm("是否退出系统并返回网站, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            localStorage.clear();
              utils.cookies.remove("token");
              utils.cookies.set("", "");
              window.location.href = "http://www.interkultur.com.cn/";
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.v-modal {
  z-index: 888 !important;
}
.user {
  margin-right: 3.5rem;
  display: flex;
  align-items: center;
  z-index: 1000;
  height: 100%;
  z-index: 99999;
  .thumb {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #000;
    margin-right: 0.88rem;
    background-size: contain;
  }
  .userbox {
    width: 100%;
    height: 100%;
    border-top: 1px solid rgba(185, 203, 215, 1);
  }
  .info {
    display: flex;
    flex-direction: column;
    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #f6f7f9;
      line-height: 34px;
    }
    .id {
      font-size: 0.88rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
    }
  }
  .theme,
  .close {
    width: 16px;
    height: 10px;
    border: 0;
    margin-left: 30px;
    background: #1872c4;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    i {
      font-size: 20px;
      color: #fff;
    }
  }
  .close {
    svg {
      width: 23px;
      height: 23px;
    }
  }
  .box-top {
    li {
      width: 100%;
      height: 40px;
      margin-top: 30px;
      display: flex;
      h4:first-of-type {
        font-size: 14px;
        line-height: 29px;
        padding-left: 140px;
      }
      h4:last-of-type {
        font-size: 14px;
        line-height: 29px;
        padding-left: 45px;
      }
      input {
        display: inline-block;
        min-width: 180px;
        height: 29px;
        background: rgba(243, 244, 250, 1);
        border-radius: 8px;
        outline: none;
        padding-left: 5px;
      }
      img {
        width: 41px;
        height: 39px;
        border-radius: 14px;
      }
      select {
        min-width: 180px;
        height: 29px;
        background: rgba(243, 244, 250, 1);
        border-radius: 8px;
        outline: none;
        padding-left: 5px;
      }
    }
  }
  .box-bottom {
    li {
      width: 100%;
      height: 40px;
      margin-top: 30px;
      display: flex;
      h4:first-of-type {
        font-size: 14px;
        line-height: 29px;
        padding-left: 45px;
      }
      h4:last-of-type {
        font-size: 14px;
        line-height: 29px;
        padding-left: 45px;
      }
      input {
        display: inline-block;
        min-width: 180px;
        height: 29px;
        background: rgba(243, 244, 250, 1);
        border-radius: 8px;
        outline: none;
        padding-left: 5px;
      }
    }
  }
}
.body-box {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 83%;
  height: 100%;
}
.dialog-footer {
  display: block;
  text-align: center;
}
</style>
